import {createContext} from 'react'

export const DiscountContext = createContext({
  modalOpen: false,
  setModalOpen: () => {
  },
  gridRowCount: 0,
  setGridRowCount: () => {
  },
  gridCurrentPage: 1,
  setGridCurrentPage: () => {
  },
  discount: {
    id: null,
    type: "",
    code: "",
    percentage: null,
    maxValue: null,
    maxValueUsage: null,
    maxCountUsage: null,
    expirationDate: "",
    description: "",
    status: "",
    updatedAt: "",
  },
  setDiscount: () => {
  },
  discounts: [],
  setDiscounts: () => {
  },
  lastDataRefresh: Date.now(),
  setLastDataRefresh: () => {
  },
  gridTotalRowCount: 0,
  setGridTotalRowCount: () => {
  },
  sortBy: "id",
  setSortBy: () => {
  },
  sortType: false,
  setSortType: () => {
  },
  from: 1,
  setFrom: () => {
  },
  to: 5,
  setTo: () => {
  },

})